import { createRoutine } from "redux-saga-routines";

export const getActionsForEventRoutine = createRoutine('GET_ACTIONS_FOR_ROUTINES');
export const getActionsForEventByInternalIdsRoutine = createRoutine('GET_ACTIONS_FOR_EVENT_BY_INTERNAL_IDS');
export const removeActionsRoutine = createRoutine('REMOVE_ACTIONS');
export const addLiveAction = createRoutine('ADD_LIVE_ACTION');
export const getActionsForEventByRbId = createRoutine('GET_ACTIONS_BY_RB_ID');
export const addCurrentlyWatchedEventRoutine = createRoutine('ADD_CURRENTLY_WATCHED_EVENT');
export const removeCurrentlyWatchedEventRoutine = createRoutine('REMOVE_CURRENTLY_WATCHED_EVENT');